import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../mensajes2";
import { Dimmer } from "../spinner";

import { validaSoloNumero, formatMoneda, validaMonto } from "../../util/varios";
import "react-tabs/style/react-tabs.css";
import axios from "axios";
import CatalogoAllCuentasContables from "../../catalogos/catalogoAllCuentasContables";
import { Input, SearchInput } from "../../ui/inputs/Input";
import { DangerButton, SuccessButton } from "../../ui/buttons/Button";

export const ModalSaldoInicial = (props) => {
  let op = require("../../../src/modulos/datos");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const fechasistema = JSON.parse(localStorage.getItem("fechasistema"));

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const txtIdPlan = useRef();
  const txtDatos = useRef();
  const txtDebe = useRef();
  const txtHaber = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [cuenta, setCuenta] = useState();
  const [activate, setActivate] = useState(false);
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [visible, setVisible] = useState(false);
  const [values, setValues] = useState();
  const txtId = useRef();
  const txtPorcen = useRef();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  let token = localStorage.getItem("jwtToken");

  const validarCampos = (e) => {
    e.preventDefault();
    var sigue = true;
    if (operacion !== 4) {
      if (txtIdPlan.current.value.trim() === "") {
        setMensaje({
          mostrar: true,
          titulo: "Información",
          texto: "Debe seleccionar una cuenta",
          icono: "informacion",
        });

        sigue = false;
        txtIdPlan.current.focus();
      } else if (txtDebe.current.value.trim() === "") {
        setMensaje({
          mostrar: true,
          titulo: "Información",
          texto: "Ingrese el monto del Debe",
          icono: "informacion",
        });

        sigue = false;
        txtDebe.current.focus();
      } else if (txtHaber.current.value.trim() === "") {
        setMensaje({
          mostrar: true,
          titulo: "Información",
          texto: "INgrese el monto del Haber",
          icono: "informacion",
        });

        sigue = false;
        txtHaber.current.focus();
      } else if (sigue === true) {
        actualizarSaldo();
      }
    }
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", ".")
      ) === 0.0
    ) {
      event.target.value = "0,00";
    }
    if (event.which >= 37 && event.which <= 40) {
      event.preventDefault();
    }
    if (event.which === 13) {
      btnAcepta.current.focus();
      /* if (event.target.id === "inputPorcen") {
        txtPorcen.current.focus();
      } */
    }

    // Devuelve el número formateado
    let e = event.target.value
      .replace(/\D/g, "")
      .replace(/([0-9])([0-9]{2})$/, "$1.$2")
      .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",");

    return formatMoneda(e);
  };

  const cerrarModal = () => {
    props.onHideRenderizar();

    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });

    props.onHideCancela();
  };

  const actualizarSaldo = () => {
    let endpoint;

    if (operacion === 1) {
      endpoint = `${op.conexion}/api/contabilidadfis/saldoinicialcrear`;
    } else if (operacion === 2) {
      endpoint = `${op.conexion}/api/contabilidadfis/saldoinicialmodificar`;
    } else if (operacion === 3) {
      endpoint = `${op.conexion}/api/contabilidadfis/saldoinicialrever`;
    }
    let body;
    setActivate(true);

    body = {
      m_cCta: cuenta.trim(),
      m_nMontodebe: txtDebe.current.value.replace(/\./g, "").replace(",", "."),
      m_nMontohaber: txtHaber.current.value
        .replace(/\./g, "")
        .replace(",", "."),
      m_nEfiscal: idefiscal,
      m_nIdCta: txtIdPlan.current.value,
      m_dFecmov: fechasistema,
    };

    console.log(body);

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (props.operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente.",
              icono: "exito",
            });
          } else if (props.operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente.",
              icono: "exito",
            });
          } else if (props.operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente.",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const blanquearCampos = () => {
    txtId.current.value = "";
    txtIdPlan.current.value = "";
    txtDatos.current.value = "";
    txtDebe.current.value = "";
    txtHaber.current.value = "";
    setValues();
  };

  const salir = () => {
    props.onHideCancela();
    blanquearCampos();
  };

  function maskIt(pattern, value) {
    let position = 0;
    let currentChar = 0;
    let masked = "";
    while (position < pattern.length && currentChar < value.length) {
      if (pattern[position] === "0") {
        masked += value[currentChar];
        currentChar++;
      } else {
        masked += pattern[position];
      }
      position++;
    }
    return masked;
  }

  const seleccionarRegistroTipReten = (id) => {
    setMostrar(false);

    let campos = "*";
    let nomtab = "plancuenta";
    let nomid = "idplancuenta";
    let nomid2 = "idefiscal";

    let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=${idefiscal}`;

    console.log(endpoint);

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data[0].cargable) {
            console.log(response.data);
            setCuenta(response.data[0].codigocuenta);
            txtIdPlan.current.value = response.data[0].idplancuenta;
            txtDatos.current.value =
              maskIt("00-000-00-00-000", response.data[0].codigocuenta) +
              "  /  " +
              response.data[0].descripcion.trim();
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "LA CUENTA NO ES MOVIMIENTO",
              icono: "informacion",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const validarTipoReten = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarRegistroTipReten(event.target.value);
      } else {
      }
    }
  };

  const validarCuenta = (values) => {
    seleccionarRegistroTipReten(values.idplancuenta);
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        
        setOperacion(props.operacion);
        if (props.operacion !== 1) {
          setDeshabilitado(true);
          setValues(props.cuenta);
          setCuenta(props.cuenta ? props.cuenta.codigocuenta : "");
          txtDebe.current.value = formatMoneda(props.cuenta.debe.replace(",", "").replace(".", ","), ",", ".",2);
          txtHaber.current.value = formatMoneda(props.cuenta.haber.replace(",", "").replace(".", ","), ",", ".",2);
        } else {
          txtDebe.current.value = "0,00";
          txtHaber.current.value = "0,00";
        }

        setVisible(false);
      }}
    >
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant">
        <h3 className="fw-bold m-0">
          {operacion === 1
            ? "Agregar Saldo Incial."
            : operacion === 2
            ? "Editar Saldo Incial."
            : operacion === 3
            ? "Eliminar Saldo Incial."
            : "Consultar Saldo Incial."}
        </h3>
        <a
          type="button"
          ref={btnCancela}
          onClick={salir}
          className="fw-bold text-light fs-6"
        >
          Salir<i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <div className=" col-12 m-0 p-0 d-flex flex-wrap">
          <div class="col-4 m-0 mb-2 p-0 pr-2">
            <Input
              label="Id Cuenta:"
              disabled={true}
              defaultValue={values ? values.idcuentacontable : ""}
              id="inputCodigo"
              ref={txtId}
            />
          </div>
          <div class="col-12 m-0 mb-2 p-0 d-flex">
            <SearchInput
              label="Cuenta Contable:"
              disabled={
                operacion == 3 ? true : operacion == 4 ? true : deshabilitado
              }
              defaultValue={
                values && values.idplancuenta
                  ? values.idplancuenta !== null
                    ? values.idplancuenta
                    : ""
                  : ""
              }
              onKeyUp={validarTipoReten}
              onBlur={validarTipoReten}
              id="inputPorcen"
              onClickButton={() => {
                setMostrar(true);
              }}
              disabledButton={
                //operacion === 1 ? false : operacion === 2 ? false : true
                operacion === 1 ? false : true
              }
              ref={txtIdPlan}
            />
            <Input
              disabled
              defaultValue={
                values
                  ? maskIt("00-000-00-00-000", values.codigocuenta) +
                    "   /   " +
                    values.descripcion.trim()
                  : ""
              }
              ref={txtDatos}
            />
          </div>
          <div className="col-12 m-0 p-0 d-flex justify-content-end gap-2">
            <div class="col-4 m-0 p-0">
                <Input
                label="Monto Debe:"
                disabled={
                    operacion == 3 ? true : operacion == 4 ? true : false
                }
                /* defaultValue={
                    values && values.debe
                    ? values.debe !== null
                        ? formatMoneda(
                            values.debe.replace(",", "").replace(".", ","),
                            ",",
                            ".",
                            2
                        )
                        : "0,00"
                    : "0,00"
                } */
                onKeyUp={handleInputMontoChange}
                id="inputPorcen"
                ref={txtDebe}
                align="right"
                />
            </div>
            <div class="col-4 m-0 p-0">
                <Input
                label="Monto Haber:"
                disabled={
                    operacion == 3 ? true : operacion == 4 ? true : false
                }
                /* defaultValue={
                    values && values.haber
                    ? values.haber !== null
                        ? formatMoneda(
                            values.haber.replace(",", "").replace(".", ","),
                            ",",
                            ".",
                            2
                        )
                        : "0,00"
                    : "0,00"
                } */
                onKeyUp={handleInputMontoChange}
                id="inputPorcen"
                ref={txtHaber}
                align="right"
                />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          disabled={operacion === 4 ? true : false}
          onClick={validarCampos}
          ref={btnAcepta}
        >
            Aceptar
        </SuccessButton>
        <DangerButton
          onClick={salir}
          ref={btnCancela}
        >
            Salir
        </DangerButton>
      </Modal.Footer>
      <CatalogoAllCuentasContables
        show={mostrar}
        onHideCancelar={() => {
          setMostrar(false);
        }}
        onHideAceptaCatalogo={validarCuenta}
      />

      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({
                mostrar: false,
                titulo: "",
                texto: "",
                icono: "",
              });
        }}
      />

      <Dimmer active={activate} inverted></Dimmer>
    </Modal>
  );
};
